import React, { FC } from 'react';
import { PlatformAdminApi } from 'src/services/GrpcService';
import { Divider } from '../../../../libs/ui-kit/common/Divider';

interface IMetroStations {
  stations: PlatformAdminApi.IMetroStation[];
}

export const MetroStations: FC<IMetroStations> = ({ stations }) =>
  stations.length ? (
    <>
      <div className="font-regular-sm text-muted">Ближайшие станции метро</div>
      {stations.map((station) => (
        <span key={`metro-${station.name}-${station.color}`}>
          <div className="font-regular-base" style={{ color: `${station.color}` }}>
            <span>{station.name}</span>
            <Divider />
            <span>{`${station.distance} км`}</span>
          </div>
        </span>
      ))}
    </>
  ) : null;
